import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { authAPI } from '../api/client';
import { useAuthStore } from '../store';
import '../styles/auth.css';

const LoginPage = ({ onLoginSuccess }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const setToken = useAuthStore((state) => state.setToken);
  const setUser = useAuthStore((state) => state.setUser);

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    setLoading(true);
    try {
      const response = await authAPI.googleAuth(credentialResponse.credential);
      setToken(response.data.access_token);
      setUser({});
      onLoginSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка входа через Google');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="auth-brand">
            <img src="/logo.ico" alt="ALLDROP" className="auth-logo" />
            <span className="auth-brand-name">ALLDROP</span>
          </div>
          <h2 className="auth-tagline">Экономь время —<br />зарабатывай больше.</h2>
          <p className="auth-sub">Тысячи позиций от поставщиков в одном месте</p>
          <div className="auth-dots">
            <span /><span /><span />
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-box">
          <h1 className="auth-title">Добро пожаловать</h1>
          <p className="auth-hint">Войдите через Google чтобы продолжить</p>

          <div className="auth-google-btn">
            {loading ? (
              <div className="auth-loading">
                <div className="spinner" />
                <span>Входим...</span>
              </div>
            ) : (
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError('Ошибка входа через Google')}
                width="300"
                locale="ru"
                shape="rectangular"
                theme="outline"
                size="large"
                text="signin_with"
              />
            )}
          </div>

          {error && (
            <div className="auth-error">
              <span>⚠</span> {error}
            </div>
          )}

          <p className="auth-legal">
            Входя в систему, вы соглашаетесь с условиями использования
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
